// API per upload immagini/file
export async function uploadFile(file: File) {
    const formData = new FormData();
    formData.append('file', file);

    const { apiFetch } = await import('./client');
    const res = await apiFetch('/api/upload', {
        method: 'POST',
        body: formData
    });
    if (!res.ok) throw new Error('Errore upload file');
    return res.json();
}